import { callGetApiToServer } from "../callApi";

export async function getAllFaq(authtoken, skipNumber, limitNumber, courseId) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let endUrl = "v1/course-FAQs/" + courseId;

    let responseData = await callGetApiToServer(header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
